// src/app/i18n/translations.en.ts
export const TRANSLATIONS_EN = {
  heroTitle: "Welcome to The Department of cooperation",
  heroDesc: "Access your account, manage your society activities, and stay connected digitally in a secure and easy way.",
  username: "(Society: User Id / Employee: PMIS) ",
  password: "Password",
  captcha: "Security Code",
  rememberMe: "Keep me signed in",
  forgotPassword: "Forgot Password?",
  login: "Sign In",
  loginOtp: "Login with OTP",
  or: "Or continue with",
  welcomeBack: "Welcome",
  secureLogin: "Secure Portal Login",
  footer: "© 2024 Government of Himachal Pradesh"
  
  
};

export const ReTRANSLATIONS_EN = {

  signUpTitle: "Create Your Account",
  signUpDesc: "Register to access society services, manage your profile, and stay connected digitally.",

  fullName: "Full Name",
  mobileNumber: "Mobile Number",
  email: "Email Address",
  pmisNumber: "PMIS Number",
  confirmPassword: "Confirm Password",

  signUp: "Sign Up",
  alreadyHaveAccount: "Already have an account?",
  loginHere: "Sign in here",

  acceptTerms: "I agree to the Terms & Conditions",
  verifyOtp: "Verify OTP",
  resendOtp: "Resend OTP"
};


export const forTRANSLATIONS_EN = {

  forgetPasswordTitle: "Reset Your Password",
  forgetPasswordDesc: "Enter your registered email, mobile number, or PMIS number to reset your password.",
  submit: "Submit",
  backToLogin: "Back to Login",
  otpSent: "OTP has been sent to your registered contact",
  resetPassword: "Reset Password",
  newPassword: "New Password",
  confirmNewPassword: "Confirm New Password",
  passwordResetSuccess: "Your password has been successfully reset. You can now login.",
  resendOtp: "Resend OTP"
};